import type CLPLabel from "../CLPLabel";
import type CLPAuditAction from "./CLPAuditAction";
import type AutoLabelViewState from "./AutoLabelViewState";
import type AttachmentLabelInheritanceViewState from "./AttachmentLabelInheritanceViewState";

interface CLPViewState {
    justificationSent: boolean;
    tempCLPLabel?: CLPLabel | null; // When mandatory label show up use this temp to store selected label.
    selectedCLPLabel: CLPLabel | null;
    originalCLPLabel?: CLPLabel | null;
    existingLabelString?: string;
    nonTenantLabelString?: string;
    labelApplyMethod: LabelApplyMethod;
    labelChanged: boolean;
    autoLabelViewState: AutoLabelViewState;
    auditActionStack: CLPAuditAction[];
    showLLbuttonAsIcon: boolean | false;
    doNotCarryForwardIRM: boolean;
    // Stores the original mail label before inheritance and any automatically or recommended inherited label.
    attachmentLabelInheritanceViewState: AttachmentLabelInheritanceViewState;
}

export enum LabelApplyMethod {
    Manual = "manual",
    Automatic = "automatic",
    Inheritance = "inheritance",
    Default = "default"
}
export type { CLPViewState as default };
